import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/resume-formatting-checker/FormattingCheckerContent.tsx");
